import React from 'react'
import clsx from 'clsx'
import { More, Send, Trash } from 'iconsax-react'
import Button from '../../../atoms/Button2'

import useStyles from './styles'

const EndControls = ({
  onSubmit,
  submitText = 'SEND',
  SubmitIcon = Send,
  iconLeft,
  showExtraIcons = true,
  onDelete,
  showMenu,
  disabled,
  hideDelete,
  SubmitButton = Button,
  largerBtn,
  children,
  className,
  smallMedia,
  variant,
  saving,
  ...props
}) => {
  const classes = useStyles({ iconLeft })

  return (
    <div
      className={variant ? classes[variant] : clsx(classes.root, className)}
      {...props}
    >
      {showExtraIcons && (
        <>
          {!hideDelete && <Trash className={classes.icon} onClick={onDelete} />}
          {showMenu && <More className={clsx(classes.icon, classes.rotate)} />}
        </>
      )}

      <div className={classes.endButtons}>
        <SubmitButton
          loading={saving}
          disabled={disabled}
          onClick={onSubmit}
          className={clsx(classes.submit, largerBtn && classes.largerBtn)}
        >
          {iconLeft && !smallMedia && <SubmitIcon className='icon' />}

          <span>{submitText}</span>

          {!iconLeft && <SubmitIcon className='icon' />}
        </SubmitButton>

        {children}
      </div>
    </div>
  )
}

export default EndControls
